<template lang="pug">
v-text-field(
  v-bind="$attrs"
  v-on="$listeners"
  :rules="hostRules"
  label='Azure AD Tenant Id'
  data-track="tenantId"
  dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputHost extends Vue {
  hostRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Tenant Id is required'];
}
</script>
